/**
 *
 * DeleteTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CircleIcon from 'assets/v2/CircleIcon';
import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.red};
    background: ${COLORS.crayolaLight};
    border-color: ${COLORS.red};

    &&& .MuiChip-icon path {
      fill: ${COLORS.red};
    }
  }
`;

const DeleteTag = (props) => (
  <StyledTag label="Delete" icon={<CircleIcon />} {...props} />
);

export default memo(DeleteTag);
